export const ADDITIONAL_NOTES = "additionalNotes" as const;
export const DELIVERY_ADDRESS = "deliveryAddress" as const;

type AVAILABLE_CACHE_TYPES = typeof ADDITIONAL_NOTES | typeof DELIVERY_ADDRESS;
type AVAILABLE_CACHE_VALUES = string | number | object | undefined;

export type CACHE_TYPE = {
    [key in AVAILABLE_CACHE_TYPES]: AVAILABLE_CACHE_VALUES;
}

export default class LocalStorage {
    protected cache: CACHE_TYPE;

    constructor() {
        try {
            const storedCache = localStorage.getItem("cart");
            this.cache = storedCache ? JSON.parse(storedCache) : {};
        } catch {
            this.cache = {
                [ADDITIONAL_NOTES]: undefined,
                [DELIVERY_ADDRESS]: undefined,
            };
        }
    }

    set(key: AVAILABLE_CACHE_TYPES, value: AVAILABLE_CACHE_VALUES) {
        this.cache[key] = value;

        localStorage.setItem("cart", JSON.stringify(this.cache));
    }

    get(key: AVAILABLE_CACHE_TYPES): AVAILABLE_CACHE_VALUES {
        return this.cache[key] ?? undefined;
    }
}